import React from 'react';
import TrackingSimpleTables from './TrackingSimpleTable';
import { useEffect,useState } from 'react';
import { deleteTracking} from '../../redux/actions/Tracking/TrackingAction';
import { connect } from 'react-redux';
import TrackingProductModal from './TrackingProductModal';
const TrackingTable=({deleteTracking,trackings}) => {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        console.log('trackings', trackings);
        const tracks=trackings;
        setRows(() => {
            return tracks && tracks.map(tracking => {
                return {
                    trackingId:tracking.trackingId, 
                    customerId:tracking.customer.customerId,
                    firstName: tracking.customer.firstName, 
                    lastName: tracking.customer.lastName,
                    status: tracking.status
                };
            });
        });
    }, [trackings]);
    const columns = [
        {
            label: 'Tracking Id',
            field: 'trackingId',
        },
        {
            label: 'Customer ID',
            field: 'customerId',
        },
        {
            label: 'Customer First Name',
            field: 'firstName',
        },
        {
            label: 'Customer Last Name',
            field: 'lastName',
        },
        {
            label: 'Status',
            field: 'status',
        },
        {
            label: 'Change Status',
            field: 'ChangeStatus',
        }
    ];
    const handleSubmit = (id) => {
        deleteTracking(id);
        
    };
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => setShow(true);
    const[data,setData]=useState([]);
    const handleShowProducts=(trackingId)=>{
        console.log('tracking',trackings);
        const tracking=trackings.filter((tracking)=>trackingId===tracking.trackingId);
        setData(tracking[0].products);
        console.log('prods',data);
        handleShow();
    };
    return(
        <>
            <TrackingSimpleTables rows={rows} columns={columns} handleSubmit={handleSubmit} handleShowProducts={handleShowProducts}/>
            <TrackingProductModal show={show} handleClose={handleClose} data={data}/>
        </>
    );
};
const mapStateToProps = (state) => ({
    tracking: state,
});
const mapDispatchToProps={
    deleteTracking,
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackingTable);